import { render } from "./UpgradePlan.vue?vue&type=template&id=029c8d24&scoped=true&ts=true"
import script from "./UpgradePlan.vue?vue&type=script&lang=ts"
export * from "./UpgradePlan.vue?vue&type=script&lang=ts"

import "./UpgradePlan.vue?vue&type=style&index=0&id=029c8d24&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-029c8d24"]])

export default __exports__